// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3x2k5","footer":"ModalUpdate_footer__wG355"};